import React, { useEffect, useState, useContext, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import {
  useFetchApi,
  Config,
  useRedirect,
  useQueryParams,
} from "@itarget/shared";
import { subscription, auth, payment, toast } from "../../redux";
import LessonView from "./views/LessonView";
import { SidebarContext } from "../../context/SidebarContext";
import { debounce, isNumber } from "lodash";
import { useReRegisterRedirect } from '../../hooks/useReRegisterRedirect';

const LessonContainer = () => {
  const getStateFromLocalStorage = () => {
    const value = window.localStorage.getItem("isOpen");
    return value ? value === "true" : false;
  };

  const { setOpen } = useContext(SidebarContext);

  const setStateToLocalStorage = (value) => {
    return window.localStorage.setItem("isOpen", value);
  };
  const { get } = useQueryParams();
  
  // Extrair parâmetros da URL para inicializar o formik
  const getInitialValues = () => {
    const tagSelected = get('tag_id');
    const activityTypeSelected = get('type_id');
    const eixoSelected = get('eixo_id');
    
    const initialValues = {
      desc_atv: '',
      eixo_id: eixoSelected || '',
      activity_type: activityTypeSelected ? activityTypeSelected.split(',').map(Number) : [],
      tag: tagSelected ? tagSelected.split(',').map(Number) : [],
      data_inicio_aga: '',
      data_fim_aga: ''
    };
    
    return initialValues;
  };
  const { cc } = useParams();
  const { goTo } = useRedirect();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const routeParams = useParams();
  
  const [axis, setAxis] = useState([]);
  const [tags, setTags] = useState([]);
  const [offers, setOffers] = useState([]);
  const [filteredOffers, setFilteredOffers] = useState([]);
  const [filterLoading, setFilterLoading] = useState(false);
  const [activityType, setActivityType] = useState([]);
  const user = useSelector((state) => state.auth.user);
  const isOnlyStreaming = useSelector(
    (state) => state.streaming.isOnlyStreaming
  );
  const isAuthenticated = useSelector((state) => state.auth.isAutenticated);
  const center_cost_id = useSelector((state) => state.auth.cc);
  const [groupByOffers, setGroupByOffers] = useState("");
  const [activityTypes, setActivityTypes] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(() => {
    // Inicializar imediatamente com valores da URL
    const tagSelected = get('tag_id');
    const activityTypeSelected = get('type_id');
    const eixoSelected = get('eixo_id');
    
    return {
      desc_atv: '',
      eixo_id: eixoSelected || '',
      activity_type: activityTypeSelected ? activityTypeSelected.split(',').map(Number) : [],
      tag: tagSelected ? tagSelected.split(',').map(Number) : [],
      data_inicio_aga: '',
      data_fim_aga: ''
    };
  });
  const [showQuiz, setShowQuiz] = useState();
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
  const isCheckboxMarked = Object.values(selectedCheckboxes).some(
    (checkbox) => checkbox == true
  );
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [categorySelected, setCategorySelected] = useState(false);
  const [openModalReceipt, setOpenModalReceipt] = useState(false);
  const selectedLang = useSelector((state) => state.language.lang);
  const settingCourse = useSelector((state) => state.setting.settingCommerce);
  const [dataPersonCenterCostApi, setDataPersonCenterCostApi] = useState({});
  const centerCost = useSelector((state) => state.setting.centerCost);
  const [lesson, setLesson] = useState(null)
  const [alert, setAlert] = useState({ message: "", open: false });

  const [showVideo, setShowVideo] = useState(false)
  const [endVideo, setEndVideo] = useState(false)
  const [totalWatch, setTotalWatch] = useState(0)
  const [percentNextVideo, setPercentNextVideo] = useState(1)
  const [progress, setProgress] = useState({
    playedSeconds: 0,
    played: 0,
    loadedSeconds: 0,
    loaded: 0,
  })

  const userPermissions = useSelector(
    (state) => state.fidelity.userPermissions
  );
  const {
    data: listOffers,
    isLoading: isLoadingListOffers,
    fetchData: fetchListOffers,
  } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/activity-schedule/lesson?centro_custo_id=${cc}` +
      (user?.data?.id ? `&pessoa_id=${user.data.id}` : "")
  );

  const { data: category, fetchData: fetchListCategory } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/center-cost/${cc}/category?pessoa_id=${user?.data?.id}&visivel_mod_congresso=S`
  );

  const { data: personCenterCost, fetchData: fetchPersonCenterCost } =
    useFetchApi(
      Config.baseURL +
        `api/${selectedLang}/center-cost-person?pessoa_id=${user?.data?.id}&centro_custo_id=${cc}`,
      "POST"
    );
  //comprovante categoria
  const { data: dataPersonCenterCost, fetchData: fetchDataPersonCenterCost } =
    useFetchApi(
      Config.baseURL +
        `api/${selectedLang}/center-cost-person/${user?.data?.id}/category-rule?centro_custo_id=${cc}`
    );

  const { data: idReceipt, fetchData: fetchIdReceipt } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/attachments?table=pessoas_centros_custos&tabela_id=${dataPersonCenterCostApi?.id}&tipo_documento_id[]=200`
  );

  const { data: questions, fetchData: fetchQuestions } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/question?centro_custo_id=${cc}&pessoa_id=${user?.data?.id}&destino_pergunta=17`
  );

  const { fetchData: fetchSendVideo } = useFetchApi(Config.baseURL + `api/${selectedLang}/video-frequency`, 'POST')

  const {
    data: getVideo,
    error: errorGetVideo,
    fetchData: fetchGetVideo,
  } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/video-frequency/${lesson && lesson.agenda_atividade_detalhe_id}/resume?pessoa_id=${
        user.data && user.data.id
      }`
  )

  const sendVideo = (tipo, posicao) => {
    const seconds = posicao !== undefined ? posicao.playedSeconds : progress.playedSeconds
    const position = posicao !== undefined ? posicao : progress

    if (position.loaded >= percentNextVideo) {
      tipo = 'F'
    }

    if(lesson && user.data){
      fetchSendVideo(
        JSON.stringify({
          agenda_atividade_detalhe_id: lesson.agenda_atividade_detalhe_id,
          pessoa_id: user.data.id,
          tipo: tipo,
          posicao: posicao ? posicao : progress,
          replay: totalWatch > seconds || endVideo ? 'S' : 'N',
        })
      )
    }
    
  }

  const onPause = (e) => {
    if (e?.percent < 1) {
      sendVideo('P')
    }
  }

  const onPlay = () => {
    sendVideo('I')
  }

  const onProgress = (e) => {
    if (totalWatch < e.playedSeconds) {
      setTotalWatch(e.playedSeconds)
    }
    if (e.played !== 1) {
      setProgress(e)
      sendVideo('P', e)
    }
  }

  const onEnded = () => {
    const position = {
      playedSeconds: progress.loadedSeconds,
      played: 1,
      loadedSeconds: progress.loadedSeconds,
      loaded: progress.loaded,
    }
    setTotalWatch(progress.loadedSeconds)
    sendVideo('F', position)
    setEndVideo(true)
    setProgress({ playedSeconds: 0, played: 0, loadedSeconds: 0, loaded: 0 })
  }

  const closeShowVideo = async () => {
    if (progress.loadedSeconds !== progress.playedSeconds) {
      await sendVideo('P')
    }
    resetState()
    setShowVideo(false)
  }

  const resetState = () => {
    setProgress({ playedSeconds: 0, played: 0, loadedSeconds: 0, loaded: 0 })
    setTotalWatch(0)
    setLesson('')
    setEndVideo(false)
  }

  useEffect(() => {
    if (showVideo && lesson) {
      fetchGetVideo()
    }
  }, [showVideo, lesson, fetchGetVideo])

  useEffect(() => {
    if (errorGetVideo !== null) {
      dispatch(
        toast.actions.enqueue({
          content: errorGetVideo,
          severity: 'error',
        })
      )
    }
  }, [errorGetVideo, dispatch])

  const handleCloseAlert = () => {
    setAlert({ message: "", open: false });
  };

  useEffect(() => {
    if (
      userPermissions?.cashWhoCanScore &&
      userPermissions?.cashWhoCanScore?.status === 2
    ) {
      setAlert({
        message: userPermissions?.cashWhoCanScore?.message,
        open: true,
      });
    } else {
      setAlert({
        message: "",
        open: false,
      });
    }
  }, [userPermissions?.cashWhoCanScore]);

  useReRegisterRedirect();

  useEffect(() => {
    if (centerCost?.tipo_centro_custo === 7) {
      goTo(`ead/`);
    }
  }, [centerCost]);

  useEffect(() => {
    if (
      dataPersonCenterCost?.data !== undefined &&
      dataPersonCenterCost?.data === null
    ) {
      fetchListCategory();
      setCategorySelected(true);
    }
  }, [dataPersonCenterCost?.data, fetchListCategory]);

  useEffect(() => {
    if (user?.data) {
      fetchDataPersonCenterCost();
      fetchQuestions();
    }
  }, [user?.data, fetchDataPersonCenterCost]);

  //comprovante
  useEffect(() => {
    if (personCenterCost) {
      setDataPersonCenterCostApi(personCenterCost.data);
      //fetchParceiros();#comentado pois na minha analise de código não está sendo feito nada com o data dessa requisição.
    }
  }, [personCenterCost]);

  useEffect(() => {
    if (dataPersonCenterCost) {
      setDataPersonCenterCostApi(dataPersonCenterCost.data);
    }
  }, [dataPersonCenterCost]);

  useEffect(() => {
    if (dataPersonCenterCostApi?.id) {
      fetchIdReceipt();
    }
  }, [dataPersonCenterCostApi, fetchIdReceipt]);

  //fim comprovante
  useEffect(() => {
    fetchListOffers();
  }, [
    user?.data?.id,
    routeParams.activity_id,
    personCenterCost,
    selectedLang,
  ]);

  // Atualizar selectedFilter quando os parâmetros da URL mudarem
  useEffect(() => {
    const tagSelected = get('tag_id');
    const activityTypeSelected = get('type_id');
    const eixoSelected = get('eixo_id');
    
    const newFilter = {
      desc_atv: '',
      eixo_id: eixoSelected || '',
      activity_type: activityTypeSelected ? activityTypeSelected.split(',').map(Number) : [],
      tag: tagSelected ? tagSelected.split(',').map(Number) : [],
      data_inicio_aga: '',
      data_fim_aga: ''
    };
    
    setSelectedFilter(newFilter);
    
    formik.setValues(newFilter);
  }, [location.search]);

  useEffect(() => {
    if (listOffers) {
      setAxis(listOffers.data.eixos?.filter(item => item && item.id) || []);
      setTags(listOffers.data.tags?.filter(item => item && item.id) || []);
      setOffers(listOffers.data.list);
      setFilteredOffers(listOffers.data.list);
      setGroupByOffers(listOffers.data.groupBy);
      
      if (!isCheckboxMarked) setActivityType(listOffers.data.tipo_atividade?.filter(item => item && item.id) || []);
    }
  }, [listOffers]);
  

  useEffect(() => {
    if (!offers || (typeof offers === 'object' && Object.keys(offers).length === 0)) return;
    
    setFilterLoading(true);
    
    let filtered = {};

    if (!selectedFilter?.eixo_id && !selectedFilter?.desc_atv && !selectedFilter?.activity_type?.length && !selectedFilter?.tag?.length) {
      filtered = offers;
    } else {
      Object.entries(offers).forEach(([groupName, groupItems]) => {
        
        const filteredItems = groupItems.filter(offer => {
          let matches = true;

          if (selectedFilter?.eixo_id) {
            matches = matches && offer.eixo_id && offer.eixo_id.toString() === selectedFilter.eixo_id.toString();
          }

          if (selectedFilter?.activity_type?.length && matches) {
            // Converter ambos para string para comparação
            const offerTypeStr = offer.tipo_atividade?.toString();
            const selectedTypesStr = selectedFilter.activity_type.map(t => t.toString());
            
            matches = matches && offer.tipo_atividade && selectedTypesStr.includes(offerTypeStr);
          }

          if (selectedFilter?.tag?.length && matches) {
            matches = matches && offer.tags && Array.isArray(offer.tags) && 
              offer.tags.some(tag => tag && selectedFilter.tag.includes(tag.id || tag));
          }

          if (selectedFilter?.desc_atv && matches) {
            const searchText = selectedFilter.desc_atv.toLowerCase();
            matches = matches && (
              (offer.titulo_palestra && offer.titulo_palestra.toLowerCase().includes(searchText)) ||
              (offer.atividade && offer.atividade.toLowerCase().includes(searchText)) ||
              (offer.palestrantes && offer.palestrantes.toLowerCase().includes(searchText))
            );
          }

          return matches;
        });

        if (filteredItems.length > 0) {
          filtered[groupName] = filteredItems;
        }
      });
    }

    setFilteredOffers(filtered);
    
    setTimeout(() => {
      setFilterLoading(false);
    }, 300);
  }, [offers, selectedFilter?.eixo_id, selectedFilter?.desc_atv, selectedFilter?.activity_type, selectedFilter?.tag]);

  const selectOffer = async (activity) => {
    setLesson(activity)
  };
  const selectProduct = async (product) => {
  };

  const onClickRegistered = async (activity) => {
    setLesson(activity)
  };

  useEffect(() => {
    if (
      questions &&
      questions?.data?.length > 0 &&
      !questions?.data[0]?.respondido
    ) {
      setShowQuiz(true);
    }
  }, [questions]);

  useEffect(() => {
    if (user.data && !user.data?.categoria_centro_custo_descricao && category) {
      if (category.data.length == 1) {
        const selectedOneCategory = async () => {
          await fetchPersonCenterCost(
            JSON.stringify({
              pessoa_id: user?.data?.id,
              categoria_centro_custo_id: category.data[0].id,
              categoria_centro_custo_princ: "S",
              nome_cracha: user?.data?.nome,
            })
          );
        };
        selectedOneCategory();
        setCategorySelected(false);
        let data = user.data;
        dispatch(
          auth.actions.updateUser({
            ...user,
            data: {
              ...data,
              categoria_centro_custo_descricao: category.data[0].descricao,
              categoria_centro_custo_id: category.data[0].id,
            },
          })
        );
        return;
      }
      setCategorySelected(true);
    }
  }, [category]);

  useLayoutEffect(() => {
    if (localStorage.length < 2) {
      return setStateToLocalStorage(true);
    }
  }, []);

  const onSubmit = (values) => {

    // Aplicar imediatamente no estado para refletir na lista
    setSelectedFilter({
      desc_atv: values.desc_atv || '',
      eixo_id: values.eixo_id || '',
      activity_type: Array.isArray(values.activity_type) ? values.activity_type.map(Number) : [],
      tag: Array.isArray(values.tag) ? values.tag.map(Number) : [],
      data_inicio_aga: values.data_inicio_aga || '',
      data_fim_aga: values.data_fim_aga || ''
    });

    const params = new URLSearchParams();

    const currentParams = get();
    Object.keys(currentParams).forEach(key => {
      if (!['tag_id', 'type_id', 'eixo_id'].includes(key)) {
        params.set(key, currentParams[key]);
      }
    });

    if (values.tag && values.tag.length > 0) {
      params.set('tag_id', values.tag.join(','));
    }

    if (values.activity_type && values.activity_type.length > 0) {
      params.set('type_id', values.activity_type.join(','));
    }

    if (values.eixo_id && values.eixo_id !== '') {
      params.set('eixo_id', values.eixo_id);
    }

    const searchString = params.toString();

    if (!searchString) {
      history.push(window.location.pathname);
    } else {
      history.push({
        pathname: window.location.pathname,
        search: `?${searchString}`
      });
    }
  };

  const formik = useFormik({
    initialValues: getInitialValues(),
    enableReinitialize: true,
    onSubmit,
  });

  const handleInputChangeDebounced = debounce((value) => {
    setSelectedFilter({
      ...selectedFilter,
      desc_atv: value,
      palestrante: value,
    });
  }, 500);

  useEffect(() => {
    setActivityTypes(activityType?.filter(item => item && item.id) || []);
    setSelectedCheckboxes(
      activityType?.filter(item => item && item.id).reduce((acc, curr) => {
        acc[curr.id] = false;
        return acc;
      }, {}) || {}
    );
  }, [activityType]);

  useEffect(() => {
    if (selectedActivities && selectedActivities.length > 0) {
      formik.setFieldValue("activity_type", selectedActivities.map(Number));
    }
  }, [selectedActivities]);

  const handleCheckboxChanged = (event, id) => {
    setSelectedCheckboxes({
      ...selectedCheckboxes,
      [id]: event.target.checked,
    });
  };

  const filterHandler = () => {
    if (!isCheckboxMarked) return;
    const newSelectedActivities = [];
    for (const [key, value] of Object.entries(selectedCheckboxes)) {
      if (value) {
        newSelectedActivities.push(key);
      }
    }
    setSelectedActivities(newSelectedActivities);
  };

  const handleChange = (e) => {
    setSelectedFilter({
      ...selectedFilter,
      grouping_field: e.target.value,
    });
  };

  const onOpenSidebar = () => {
    setOpen(true);
    setStateToLocalStorage(true);
  };

  const onCloseSidebar = () => {
    setOpen(false);
    setStateToLocalStorage(false);
  };

  useEffect(() => {
    const stateFromLocalStorage = getStateFromLocalStorage();
    if (stateFromLocalStorage !== null) {
      setOpen(stateFromLocalStorage);
    } else {
      setOpen(true);
      setStateToLocalStorage(true);
    }
  }, []);

  const cleanAllFilters = () => {
    setSelectedFilter({});
    setSelectedActivities([]);
    setSelectedCheckboxes({});
    
    // Resetar o formulário Formik
    formik.resetForm();
    
    // Forçar valores vazios no formik
    formik.setValues({
      desc_atv: '',
      eixo_id: '',
      activity_type: [],
      tag: [],
      data_inicio_aga: '',
      data_fim_aga: ''
    });
  };

  useEffect(() => {
    const redirectToStreaming = async () => {
      const streamingCard = offers.find((card) => {
        return card.aga_id == get("streaming_aga_id");
      });
      if (!streamingCard) return;
      dispatch(subscription.actions.setTransmissionActivity(streamingCard));
      await new Promise((resolve) => setTimeout(resolve, 100));
      goTo(`streaming`);  
    };
    if (isOnlyStreaming) redirectToStreaming();
  }, [isOnlyStreaming, offers]);

  return (
    <LessonView
      alert={alert}
      handleCloseAlert={handleCloseAlert}
      axis={axis}
      tags={tags}
      toast={toast}
      formik={formik}
      centerCostId={cc}
      payment={payment}
      idReceipt={idReceipt}
      category={category}
      offers={filteredOffers}
      groupByOffers={groupByOffers}
      settingCourse={settingCourse}
      activityType={activityType}
      categorySelected={categorySelected}
      activityTypes={activityTypes}
      loading={isLoadingListOffers}
      filterLoading={filterLoading}
      selectedFilter={selectedFilter}
      openModalReceipt={openModalReceipt}
      isCheckboxMarked={isCheckboxMarked}
      selectedCheckboxes={selectedCheckboxes}
      dataPersonCenterCostApi={dataPersonCenterCostApi}
      onOpenSidebar={onOpenSidebar}
      onCloseSidebar={onCloseSidebar}
      setOpenModalReceipt={setOpenModalReceipt}
      cleanAllFilters={cleanAllFilters}
      handleInputChangeDebounced={handleInputChangeDebounced}
      handleCheckboxChanged={handleCheckboxChanged}
      filterHandler={filterHandler}
      handleChange={handleChange}
      setSelectedFilter={setSelectedFilter}
      selectOffer={selectOffer}
      selectProduct={selectProduct}
      onClickRegistered={onClickRegistered}
      showQuiz={showQuiz}
      setShowQuiz={setShowQuiz}
      lesson={lesson}
      closeShowVideo={closeShowVideo}
      onPause={onPause}
      onPlay={onPlay}
      onProgress={onProgress}
      onEnded={onEnded}
    />
  );
};

export default LessonContainer;
